// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-button[data-v-022e2e5a] {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin-bottom: 2rem;\n}\n.header-button[data-v-022e2e5a]  .el-col {\n  width: auto;\n  margin-left: 2rem;\n}\n.header-button[data-v-022e2e5a]  .el-col .el-button {\n  font-size: inherit;\n  width: 10em;\n}\n.route-code[data-v-022e2e5a]  .el-form-item__content {\n  width: 6.5em;\n}\n.dummy[data-v-022e2e5a] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
